import React from 'react';
import { Calendar } from 'lucide-react';
import AppointmentsList from '../../components/schedule/AppointmentsList';
import { useProject } from '../../contexts/ProjectContext';

const AppointmentsPage: React.FC = () => {
  const { selectedProjectId, projects, setSelectedProjectId } = useProject();

  return (
    <div className="p-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        <div className="flex items-center gap-3">
          <Calendar className="h-7 w-7 text-indigo-600" />
          <h1 className="text-2xl font-bold text-gray-900">Appointments</h1>
        </div>
        {projects.length > 0 && (
          <select
            value={selectedProjectId || ''}
            onChange={(e) => setSelectedProjectId(e.target.value)}
            className="block w-full sm:w-64 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
          >
            {projects.map((project) => (
              <option key={project.id} value={project.id}>
                {project.name}
              </option>
            ))}
          </select>
        )}
      </div>

      {selectedProjectId ? (
        <AppointmentsList
          projectId={selectedProjectId}
          showActions={true}
        />
      ) : (
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <p className="text-gray-500">Select a project to view appointments.</p>
        </div>
      )}
    </div>
  );
};

export default AppointmentsPage;
